module.exports = __webpack_public_path__ + "assets/f3921bad673050ebd55909bd7bfddcf6.mp4";